var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearchIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.2507 19.2499L14.4868 14.4859M14.4868 14.4859C15.7762 13.1966 16.5005 11.4478 16.5005 9.6244C16.5005 7.80097 15.7762 6.05222 14.4868 4.76286C13.1974 3.4735 11.4487 2.74915 9.62526 2.74915C7.80183 2.74915 6.05308 3.4735 4.76372 4.76286C3.47436 6.05222 2.75 7.80097 2.75 9.6244C2.75 11.4478 3.47436 13.1966 4.76372 14.4859C6.05308 15.7753 7.80183 16.4997 9.62526 16.4997C11.4487 16.4997 13.1974 15.7753 14.4868 14.4859Z",
    stroke: "#111827",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearchIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/search-icon.cee2311cf8b9d4c68d71d953eb6e9d03.svg";